module.exports = __webpack_public_path__ + "img/warning.dfd3e67a.svg";